/** billing group: the org's own OEX subscription (entitlements) (docs/03 "Vocabulary"). A WP adds to its own group and to docs/03 in the same commit. */
export const billingPermissions = ['billing:read', 'billing:manage'] as const;

export type BillingPermission = (typeof billingPermissions)[number];
